import Vue, { Component, PropType } from 'vue';

import * as VideoStore from '@/scripts/store/modules/video';

// Video Object is what you should focus on. They rest are not important
import VideoObject from '@/scripts/pages/video/index.ts.vue';
import VideoActions from '@/scripts/pages/video/VideoActions/index.ts.vue';
import VideoInfoComponent from '@/scripts/pages/video/VideoInfo/index.ts.vue';
import VerticalRecommendedVideosSection from '@/scripts/pages/video/RelatedVideos/VerticalRecommendedVideosSection.ts.vue';
import VideoCollectionDrawer from '@/scripts/pages/video/VideoCollectionDrawer/index.ts.vue';

import VideoConversations from '@/scripts/pages/video/Conversations/index.ts.vue';
import GoogleAdUnit from '@/scripts/Components/Molecules/GoogleAdUnit.ts.vue';
import { Tabs, Tab } from 'vue-tabs-component';
import { Model } from '@viddsee/server-api-client';

type VideoConversationsComponent = InstanceType<typeof VideoConversations>;

interface SsrToken {
  createdAt: string;
  expiryDate: string;
  id: number;
  sessionToken: string;
  updatedAt: string;
  videoId: number;
}

class VSVideo {
  init(): Component {
    return Vue.extend({
      components: {
        VueTab: Tab,
        VueTabs: Tabs,
        GoogleAdUnit,
        VideoObject,
        VideoActions,
        VideoInfo: VideoInfoComponent,
        VerticalRecommendedVideosSection,
        VideoConversations,
        VideoCollectionDrawer,
      },
      props: {
        serviceType: {
          type: String,
          required: true,
        },
        video: {
          type: Object as PropType<Model.Video.Info>,
          required: true,
        },
        token: {
          type: Object as PropType<SsrToken>,
          required: true,
        },
        countryCode: {
          type: String,
          required: true,
        },
      },
      data() {
        return {
        // Data
          shouldRender: false,
          // Reference Components
          conversations: null as (VideoConversationsComponent | null),
        };
      },
      computed: {
        totalComments(): number {
          const data = (this.conversations as VideoConversationsComponent || { data: {} }).$data.data;
          return data.total_comments || 0;
        },
      },

      beforeCreate() {
        this.$store.registerModule(VideoStore.storeNamespace, VideoStore.storeModule);
      },

      created() {
        this.initVideoPlayer({
          video: this.video,
          token: this.token.sessionToken,
        });
      },
      mounted() {
        this.conversations = this.$refs.conversations as VideoConversationsComponent;

        // Render conversation on mounted only if the HTML is rendered
        // offsetParent will be null if displayWatcher is not rendered
        this.shouldRender = !!(this.$refs.displayWatcher && (this.$refs.displayWatcher as HTMLElement).offsetParent);
      },

      methods: {
        initVideoPlayer: VideoStore.mapAction('init'),

        // Render conversation component if user which to this tab
        handleTabChange({ tab }: { tab: { id: string }}): void {
          if (tab.id === 'video-tab-comment') {
            this.shouldRender = true;
          }
        },
      },
    });
  };
};

export default new VSVideo();
